export const userEventsEn = {
  stickerStateDeleted: 'Deleted state of sticker'
}

export const userEventRu: typeof userEventsEn = {
  stickerStateDeleted: 'Удалено состояние стикера'
}
